import * as ProfileTypes from "../types/profile.types";
import * as UiTypes from "../types/ui.types";
import axiosInstance from "../../api";
import { alertActions } from "./alert.actions";

export const loadPeople =
  (page: number | string, filter?: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: ProfileTypes.LOADING_PROFILE });
    if (filter) {
      page = page + "&" + filter;
    }
    axiosInstance
      .get("/people/?page=" + page)
      .then((res) => {
        dispatch({
          type: ProfileTypes.LOAD_PROFILE,
          payload: res.data,
        });
        dispatch({ type: UiTypes.CLEAR_ERRORS });
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Network Issue",
          });
        }
      });
  };

export const getProfile = () => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: ProfileTypes.FETCH_PROFILE_REQUEST });

  axiosInstance
    .get("user/userdetails")
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({
        type: ProfileTypes.FETCH_PROFILE_REQUEST_SUCCESS,
        payload: res.data,
      });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      }
    });
};

export const trashPeople = (id: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  axiosInstance
    .delete("/people/" + id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch(loadPeople(1));
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};

export const blukTrashPeople = (id: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  axiosInstance
    .delete("/people/", id)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch(loadPeople(1));
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Network Issue",
        });
      }
    });
};

export const updateProfile = (userData: any, id: number) => (dispatch: any) => {
  //dispatch({ type: UiTypes.LOADING_UI })
  dispatch({ type: ProfileTypes.PROFILE_SAVE_REQUEST });

  axiosInstance
    .put(
      "profile/" + id,
      userData /*, {
    headers:{
      'Content-Type': 'multipart/form-data'
    }
  }*/
    )
    .then((res) => {
      //dispatch({type:UiTypes.CLEAR_ERRORS});

      dispatch(alertActions.success("Profile Updated Successfully"));
      dispatch({ type: ProfileTypes.PROFILE_SAVE_SUCCESS });
      //dispatch(loadPeople(1))
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      }
    });
};

export const addStaff = (userData: any, id: number) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  dispatch({ type: ProfileTypes.PROFILE_SAVE_REQUEST });

  axiosInstance
    .post("people/", userData)
    .then((res) => {
      dispatch({ type: UiTypes.CLEAR_ERRORS });
      dispatch({ type: ProfileTypes.PROFILE_SAVE_SUCCESS });
      dispatch(alertActions.success("Staff added Successfully"));
      dispatch(loadPeople(1));
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      }
    });
};
